import { makeStyles, Theme } from '@material-ui/core';

export const useDefaultRandomAvatarStyles = makeStyles<Theme>(theme => ({
  root: {},
  img: {
    width: 17,
    height: 'auto',
  },
  avatarBox: {
    position: 'relative',
    height: '100%',
  },
  verifiedIcon: {
    width: 16,
    height: 16,
    position: 'absolute',
    right: -6,
    bottom: 0,
  },
  color0: {
    background: `
linear-gradient(360deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 50%),
linear-gradient(259.57deg, #2663FF 1.58%, #FF3828 92.54%);
`,
  },
  color1: {
    background: `
linear-gradient(151.39deg, #FFFFFF 8.02%, rgba(255, 255, 255, 0) 50%),
linear-gradient(154.33deg, #09EFB8 28.09%, #283EFF 95.62%);
`,
  },
  color2: {
    background: `
linear-gradient(120.58deg, #FFFFFF 7.6%, rgba(255, 255, 255, 0) 50%),
linear-gradient(42.07deg, #1E9600 4.68%, #FFF200 73.53%);
`,
  },
  color3: {
    background: `
linear-gradient(173.52deg, #FFFFFF -16.07%, rgba(255, 255, 255, 0) 74.88%),
linear-gradient(42.07deg, #845EC2 4.68%, #00C9A7 60.43%);
`,
  },
  color4: {
    background: `
linear-gradient(141.07deg, #FFFFFF 11.32%, rgba(255, 255, 255, 0) 38.32%),
linear-gradient(42.07deg, #C3FCF2 4.68%, #484838 95.22%);
`,
  },
  color5: {
    background: `
linear-gradient(360deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 50%),
linear-gradient(259.57deg, #F7906E 1.58%, #EFFF00 92.54%);
`,
  },
  color6: {
    background: `
linear-gradient(151.39deg, #FFFFFF 8.02%, rgba(255, 255, 255, 0) 50%),
linear-gradient(154.33deg, #09EFB8 28.09%, #283EFF 95.62%);
`,
  },
  color7: {
    background: `
linear-gradient(50.56deg, #FFFFFF -14.81%, rgba(255, 255, 255, 0) 50%),
linear-gradient(10.57deg, #ADAC9A 31.24%, #FF8B9F 69.4%);
`,
  },
  color8: {
    background: `
linear-gradient(173.52deg, #FFFFFF -16.07%, rgba(255, 255, 255, 0) 74.88%),
linear-gradient(42.07deg, #FF78E2 4.68%, #00E5FF 95.22%);
`,
  },
  color9: {
    background: `
linear-gradient(141.07deg, #FFFFFF 11.32%, rgba(255, 255, 255, 0) 38.32%),
linear-gradient(108.95deg, #0085FF 17.94%, #FF693E 76.8%);
`,
  },
  color10: {
    background: `
linear-gradient(360deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 50%),
linear-gradient(275.71deg, #0066FF 1.04%, #8875A7 57.13%);
`,
  },
  color11: {
    background: `
linear-gradient(151.39deg, #FFFFFF 8.02%, rgba(255, 255, 255, 0) 50%),
linear-gradient(75.91deg, #00FFE0 12.47%, #362B48 69.99%);
`,
  },
  color12: {
    background: `
linear-gradient(120.58deg, #FFFFFF 7.6%, rgba(255, 255, 255, 0) 50%),
linear-gradient(42.07deg, #955BFF 4.68%, #005244 95.22%);
`,
  },
  color13: {
    background: `
linear-gradient(173.52deg, #FFFFFF -16.07%, rgba(255, 255, 255, 0) 74.88%),
linear-gradient(42.07deg, #D5FD7F 4.68%, #00C9A7 60.43%);
`,
  },
  color14: {
    background: `
linear-gradient(360deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 50%),
linear-gradient(275.71deg, #6ACDFF 1.04%, #D939D2 57.13%);
`,
  },
  color15: {
    background: `
linear-gradient(151.39deg, #FFFFFF 8.02%, rgba(255, 255, 255, 0) 50%),
linear-gradient(107.65deg, #86B963 32.01%, #589D90 56.02%);
`,
  },
  color16: {
    background: `
linear-gradient(120.58deg, #FFFFFF 7.6%, rgba(255, 255, 255, 0) 50%),
linear-gradient(78.44deg, #97B1AB 54.27%, #6ACDFF 98.46%);
`,
  },
  color17: {
    background: `
linear-gradient(173.52deg, #FFFFFF -16.07%, rgba(255, 255, 255, 0) 74.88%),
linear-gradient(42.07deg, #545479 38.84%, #FF856A 95.22%);
`,
  },
  color18: {
    background: `
linear-gradient(120.58deg, #FFFFFF 7.6%, rgba(255, 255, 255, 0) 50%),
linear-gradient(92.68deg, #E9FF70 20.09%, #FF0054 84.6%);
`,
  },
  color19: {
    background: `
linear-gradient(173.52deg, #FFFFFF -16.07%, rgba(255, 255, 255, 0) 74.88%),
linear-gradient(73.59deg, #B6CCFE 18.99%, #68D6D1 66.89%);
`,
  },
}));
